import React from 'react'
import {View, StyleSheet, Text} from 'react-native'
import Style from '../../Style'
interface IProps {}

const Deeplink: React.FC<IProps> = ({children}) => {
  return (
    <View style={{paddingTop: 40}}>
      <Text style={{color: '#000', fontSize: 20}}>
        Deeplink, you are being redirected to the app
      </Text>
    </View>
  )
}

export default Deeplink

const styles = StyleSheet.create({})
